document.addEventListener("DOMContentLoaded", function () {
  // *.*.*.*.*.*.*.*.*.*.* Website directrion for js usage *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  const direction = document.documentElement.getAttribute("dir");

  // *.*.*.*.*.*.*.*.*.*.* START: Splide splider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  if (document.getElementById("splide")) {
    var splide = new Splide("#splide", {
      type: "loop",
      perPage: 1,
      autoplay: true,
      interval: 5000,
      pauseOnHover: false,
      pauseOnFocus: false,
      resetProgress: false,
      pagination: false,
      direction: direction,
    });
    splide.mount();
  }

  if (document.getElementById("splide-carousel")) {
    var splide = new Splide("#splide-carousel", {
      type: "loop",
      perPage: 2,
      autoplay: true,
      interval: 5000,
      pauseOnHover: false,
      pauseOnFocus: false,
      resetProgress: false,
      pagination: false,
      gap: "1rem",
      direction: direction,
      breakpoints: {
        768: {
          perPage: 1,
        },
      },
    });
    splide.mount();
  }

  // *.*.*.*.*.*.*.*.*.*.* END: Splide splider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF TABs *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  function setupTabs(tabButtons, contentBoxes, container) {
    const tabs = Array.from(container.querySelectorAll(tabButtons));
    const contents = Array.from(container.querySelectorAll(contentBoxes));

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabs.forEach((tab, i) => {
          if (i === index) {
            tab.classList.add("active");
            contents[i].classList.add("visible");
          } else {
            tab.classList.remove("active");
            contents[i].classList.remove("visible");
          }
        });
      });
    });
  }

  document.querySelectorAll(".tab-list-news").forEach((container) => {
    setupTabs(".tab-toolbar button", ".tab-content", container);
  });
  // *.*.*.*.*.*.*.*.*.*.* END OF TABs *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* END OF archive toggle *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  function convertToPersianDigits(num) {
    const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return num.toString().replace(/\d/g, (digit) => persianDigits[digit]);
  }

  // *.*.*.*.*.*.*.*.*.*.* START: live clock with js *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  function updateClock() {
    const timeContainer = document.getElementById("time-container");

    // Create a new time tag
    const timeTag = document.createElement("time");

    // Get the current date and time
    const now = new Date();
    const options = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };

    if (direction == "rtl") {
      // Format the time
      const formattedTime =
        now.toLocaleTimeString([], options) +
        " - " +
        new Date().toLocaleDateString("fa-IR", { dateStyle: "medium" });
      const persianTime = convertToPersianDigits(formattedTime);
      // Set the text content of the time tag
      timeTag.textContent = persianTime;
    } else {
      const formattedTime =
        now.toLocaleTimeString([], options) +
        " - " +
        new Date().toLocaleDateString("en-US", { dateStyle: "medium" });
      // Set the text content of the time tag
      timeTag.textContent = formattedTime;
    }

    timeTag.setAttribute("datetime", new Date().toISOString());
    // Clear the previous time tag and append the new one
    timeContainer.innerHTML = ""; // Clear previous content
    timeContainer.appendChild(timeTag);
  }

  // Update the clock every second
  setInterval(updateClock, 1000);

  // Initial call to display the clock immediately
  updateClock();
  // *.*.*.*.*.*.*.*.*.*.* END: live clock with js *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* NEW JS *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  const mobileSideMenu = document.getElementById("mobile-side-menu");
  const OpenMenuButton = document.getElementById("open-menu-button");
  const CloseMenuButton = document.getElementById("close-menu-button");
  const closeArea = document.getElementById("close-area");

  OpenMenuButton.addEventListener("click", function () {
    mobileSideMenu.classList.add("active");
  });
  closeArea.addEventListener("click", function () {
    mobileSideMenu.classList.remove("active");
  });
  CloseMenuButton.addEventListener("click", function () {
    mobileSideMenu.classList.remove("active");
  });
  // *.*.*.*.*.*.*.*.*.*.* END: live clock with js *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START: search button handler *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  const searchBtn = document.getElementById("search-btn");
  const searchInput = document.getElementById("search-input");
  searchBtn.addEventListener("click", function () {
    searchBtn.style.display = "none";
    searchInput.classList.add("active");
    searchInput.focus();
  });

  window.onclick = function (event) {
    if (
      !event.target.matches(".search") &&
      !event.target.matches(".search-btn") &&
      !event.target.matches(".search-input") &&
      !event.target.matches(".search-path")
    ) {
      document.querySelectorAll(".search-input").forEach((dropdown) => {
        searchBtn.style.display = "flex";
        searchInput.classList.remove("active");
      });
    }
  };
  // *.*.*.*.*.*.*.*.*.*.* END: search button handler *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START: equal elements height inside one section *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
  if (width >= 992) {
    if (document.getElementById("special-slider")) {
      var specialSlider = document.getElementById("special-slider");
      var specialMatnBox = document.querySelector(
        ".special-section .left_side .matn_box",
      );
      // elements placed below the lists in the left column (poll, ad, ...)
      var belowListsElements = specialMatnBox
        ? Array.from(specialMatnBox.parentElement.children).filter(
            (element) =>
              specialMatnBox.compareDocumentPosition(element) &
              Node.DOCUMENT_POSITION_FOLLOWING,
          )
        : [];

      var setSpecialSectionHeight = function () {
        // shrink the lists so the left column ends with the slider
        var belowListsHeight = 0;
        belowListsElements.forEach((element) => {
          if (element.offsetHeight) {
            belowListsHeight = Math.max(
              belowListsHeight,
              element.getBoundingClientRect().bottom -
                specialMatnBox.getBoundingClientRect().bottom,
            );
          }
        });
        var specialSliderHeight = Math.max(
          specialSlider.offsetHeight - 42 - belowListsHeight,
          200,
        );
        document
          .querySelectorAll(
            ".special-section .tab-body, .special-section .list-body",
          )
          .forEach((element) => {
            element.style.height = specialSliderHeight + "px";
          });
      };

      setSpecialSectionHeight();
      // ads and images can change the heights after load
      window.addEventListener("load", setSpecialSectionHeight);
      if (window.ResizeObserver) {
        var specialResizeObserver = new ResizeObserver(setSpecialSectionHeight);
        specialResizeObserver.observe(specialSlider);
        belowListsElements.forEach((element) =>
          specialResizeObserver.observe(element),
        );
      }
    }

    if (document.getElementById("special-news")) {
      var specialNewsHeight =
        document.getElementById("special-news").offsetHeight - 42;
      var bodies3 = document.querySelectorAll(
        ".list-news-selector-first .list-news .list-body",
      );
      if (bodies3.length) {
        bodies3.forEach((element) => {
          element.style.height = specialNewsHeight + "px";
        });
      }
    }

    if (document.getElementById("special-news-two")) {
      var specialNewsHeight =
        document.getElementById("special-news-two").offsetHeight - 42;
      var bodies4 = document.querySelectorAll(
        ".list-news-selector-second .list-news .list-body",
      );
      if (bodies4.length) {
        bodies4.forEach((element) => {
          element.style.height = specialNewsHeight + "px";
        });
      }
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END: equal elements height inside one section *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START: force news section handler *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  const forceNews = document.getElementsByClassName("force-news-area");
  if (forceNews.length) {
    document.getElementById("main-footer").style.paddingBottom =
      forceNews[0].offsetHeight + "px";
    document
      .getElementById("close-force-news")
      .addEventListener("click", function () {
        forceNews[0].style.display = "none";
      });
  }
  // *.*.*.*.*.*.*.*.*.*.* END: force news section handler *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
});
